/*!

=========================================================
* Paper Dashboard React - v1.3.0
=========================================================

* Product Page: https://www.creative-tim.com/product/paper-dashboard-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)

* Licensed under MIT (https://github.com/creativetimofficial/paper-dashboard-react/blob/main/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React,{useEffect,useState} from "react";
import firebase from '../config/firebase'
import clientFirebase from '../config/firebase_client'
// reactstrap components
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  CardTitle,
  FormGroup,
  Form,
  Input,
  Row,
  Col,
} from "reactstrap";

function Add() {

let [currentUpload,setCurrentUpload]=useState('')

let [progress,setProgress]=useState('0')

let [name,setName]=useState('')
let [nameValidation,setNameValidation]=useState('')

let [email,setEmail]=useState('')
let [emailValidation,setEmailValidation]=useState('')

let [phone,setPhone]=useState('')
let [phoneValidation,setPhoneValidation]=useState('')

let [Firstname,setFirstName]=useState('')
let [FirstnameValidation,FirstsetNameValidation]=useState('')

let [LastName,setLastName]=useState('')
let [LastnameValidation,LastsetNameValidation]=useState('')

let [roomNo,setRoomNo]=useState('')
let [roomNoValidation,setRoomNoValidation]=useState('')

let [price,setPrice]=useState('')
let [priceValidation,setpriceValidation]=useState('')

let [accomodation,setaccomodation]=useState('')
let [accomodationValidation,setaccomodationValidation]=useState('')

let [address,setAddress]=useState('')
let [addressValidation,setAddressValidation]=useState('')

let [country,setCountry]=useState('')
let [countryValidation,setCountryValidation]=useState('')

let [zip,setZip]=useState('')
let [zipValidation,setzipValidation]=useState('')

let [Details,setDetails]=useState('')
let [DetailsValidation,setdetailsValidation]=useState('')

let [city,setCity]=useState('')
let [cityValidation,setcityValidation]=useState('')

let [facilities,setFacilities]=useState('')
let [facilitiesValidation,setfacilitiesValidation]=useState('')
  

let [image1,setimage1]=useState('')
let [image1Validation,setimage1Validation]=useState('')

let [image2,setimage2]=useState('')
let [image2Validation,setimage2Validation]=useState('')

let [image3,setimage3]=useState('')
let [image3Validation,setimage3Validation]=useState('')

let [image4,setimage4]=useState('')
let [image4Validation,setimage4Validation]=useState('')

let [image5,setimage5]=useState('')
let [image5Validation,setimage5Validation]=useState('')


let [image6,setimage6]=useState('')
let [image6Validation,setimage6Validation]=useState('')


// clientFirebase.firestore().collection('allHotel')
// .get().then((doc) => {
//   if (doc.exists) {
//       console.log("Document data:", doc.data());
//   } else {
//       // doc.data() will be undefined in this case
//       console.log("No such document!");
//   }
// }).catch((error) => {
//   console.log("Error getting document:", error);
// });








  // writeUserData()
  // function writeUserData() {
  //   const db = getDatabase();
  //   set(ref(db, '/'), {
  //     username: 'asdf',
  //     email: 'email',
  //     profile_picture : 'imageUrl'
  //   });
  // }


  let AddBranch=()=>{

          setNameValidation('')
          setEmailValidation('')
          setPhoneValidation('')         
          FirstsetNameValidation('')    
          LastsetNameValidation('')
          setRoomNoValidation('')    
          setaccomodationValidation('')
          setcityValidation('')    
          setCountryValidation('')
          setzipValidation('')    
          setdetailsValidation('')    
          setfacilitiesValidation('')
          setimage1Validation('')
          setimage2Validation('')
          setimage3Validation('')
          setimage4Validation('')
          setimage5Validation('')
          setimage6Validation('')
          setpriceValidation('')
          setAddressValidation('')

         
      if(name=='' || email=='' || phone=='' ||Firstname =='' ||LastName =='' ||roomNo=='' ||accomodation=='' ||address=='' ||city=='' ||country=='' ||zip=='' ||Details=='' ||facilities=='' ||image1.length==0 ||image2.length==0 ||  image3.length==0 || image4.length==0 || image5.length==0 || image6.length==0 || price=='' )
            {

              if(name==''){
                setNameValidation('*Required')
              }
              if(email==''){
                setEmailValidation('*Required')
              }
              if(phone==''){
                setPhoneValidation('*Required')
              }
              if(Firstname==''){
                FirstsetNameValidation('*Required')
              }
              if(LastName==''){
                LastsetNameValidation('*Required')
              }
              if(roomNo==''){
                setRoomNoValidation('*Required')
              }
              if(accomodation==''){
                setaccomodationValidation('*Required')
              }
              if(price==''){
                setpriceValidation('*Required')
              }
              if(city==''){
                setcityValidation('*Required')
              }
              if(country==''){
                setCountryValidation('*Required')
              }
              if(zip==''){
                setzipValidation('*Required')
              }
              if(Details==''){
                setdetailsValidation('*Required')
              }
              if(facilities==''){
                setfacilitiesValidation('*Required')
              }
              if(image1==''){
                setimage1Validation('*Required')
              }
              if(image2==''){
                setimage2Validation('*Required')
              } 
              if(image3==''){
                setimage3Validation('*Required')
              } 
              if(image4==''){
                setimage4Validation('*Required')
              } 
              if(image5==''){
                setimage5Validation('*Required')
              } 
              if(image6==''){
                setimage6Validation('*Required')
              }
              if(address==''){
                setAddressValidation('*Required')
              }
              return
            }










document.getElementById('loadingSHOW').style.display='block'

var ref=clientFirebase.storage().ref(`/`).child(`hotel/${image1.name}`).put(image1)
setCurrentUpload('1')
ref.on('state_changed', function(snapshot){
 // Observe state change events such as progress, pause, and resume
 // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
 var progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
setProgress(Math.floor(progress))
 console.log('IMAGE 1 Upload is ' + progress + '% done');

}, function(error) {
  document.getElementById('loadingSHOW').style.display='none'

 // Handle unsuccessful uploads
 console.log(error);
}, function() {
  console.log("GET LINK>>>>>>>>>>>>>");
  ref.snapshot.ref.getDownloadURL().then(function(downloadURL) {
localStorage.setItem('Image1',downloadURL)
    




// IMAGE 2

var ref=clientFirebase.storage().ref(`/`).child(`hotel/${image2.name}`).put(image2)
setCurrentUpload('2')
ref.on('state_changed', function(snapshot){
 // Observe state change events such as progress, pause, and resume
 // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
 var progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
setProgress(Math.floor(progress))
 console.log('IMAGE 2 Upload is ' + progress + '% done');

}, function(error) {
 // Handle unsuccessful uploads
   document.getElementById('loadingSHOW').style.display='none'
('none')

 console.log(error);
}, function() {
  console.log("GET LINK>>>>>>>>>>>>>");
  ref.snapshot.ref.getDownloadURL().then(function(downloadURL) {
localStorage.setItem('Image2',downloadURL)
    



// IMAGE3

var ref=clientFirebase.storage().ref(`/`).child(`hotel/${image3.name}`).put(image3)
setCurrentUpload('3')
ref.on('state_changed', function(snapshot){
 // Observe state change events such as progress, pause, and resume
 // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
 var progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
setProgress(Math.floor(progress))
 console.log('IMAGE 3 Upload is ' + progress + '% done');

}, function(error) {
 // Handle unsuccessful uploads
   document.getElementById('loadingSHOW').style.display='none'
('none')

 console.log(error);
}, function() {
  console.log("GET LINK>>>>>>>>>>>>>");
  ref.snapshot.ref.getDownloadURL().then(function(downloadURL) {
localStorage.setItem('Image3',downloadURL)
    


// IMAGE4

var ref=clientFirebase.storage().ref(`/`).child(`hotel/${image4.name}`).put(image4)
setCurrentUpload('4')
ref.on('state_changed', function(snapshot){
 // Observe state change events such as progress, pause, and resume
 // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
 var progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
setProgress(Math.floor(progress))
 console.log('IMAGE 4 Upload is ' + progress + '% done');

}, function(error) {
 // Handle unsuccessful uploads
   document.getElementById('loadingSHOW').style.display='none'
('none')

 console.log(error);
}, function() {
  console.log("GET LINK>>>>>>>>>>>>>");
  ref.snapshot.ref.getDownloadURL().then(function(downloadURL) {
localStorage.setItem('Image4',downloadURL)
    


// Imag 5



var ref=clientFirebase.storage().ref(`/`).child(`hotel/${image5.name}`).put(image5)
setCurrentUpload('5')
ref.on('state_changed', function(snapshot){
 // Observe state change events such as progress, pause, and resume
 // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
 var progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
setProgress(Math.floor(progress))
 console.log('IMAGE 5 Upload is ' + progress + '% done');

}, function(error) {
 // Handle unsuccessful uploads
 console.log(error);
   document.getElementById('loadingSHOW').style.display='none'
('none')

}, function() {
  console.log("GET LINK>>>>>>>>>>>>>");
  ref.snapshot.ref.getDownloadURL().then(function(downloadURL) {
localStorage.setItem('Image5',downloadURL)
    




var ref=clientFirebase.storage().ref(`/`).child(`hotel/${image6.name}`).put(image6)
setCurrentUpload('6')
ref.on('state_changed', function(snapshot){
 // Observe state change events such as progress, pause, and resume
 // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
 var progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
setProgress(Math.floor(progress))
 console.log('IMAGE 6 Upload is ' + progress + '% done');

}, function(error) {
 // Handle unsuccessful uploads
 console.log(error);
   document.getElementById('loadingSHOW').style.display='none'
('none')

}, function() {
  console.log("GET LINK>>>>>>>>>>>>>");
  ref.snapshot.ref.getDownloadURL().then(function(downloadURL) {
localStorage.setItem('Image6',downloadURL)
    
function makeid(length) {
  var result           = '';
  var characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdeFGHIJKLMNOPQRSTUVWXYZabcdefghijklmFGFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789HIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789nopqrstuvwxyz0123456789fghijklmnopqrstuvwxyz0123456789';
  var charactersLength = characters.length;
  for ( var i = 0; i < length; i++ ) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
 }
 return result;
}
let key=makeid(30)
            


let obj= {
hotelName:name,
email:email,
phone:phone,
name:Firstname +LastName,
address:address,
city:city,
country:country,
zipCode:zip,
details:Details,
facilities:facilities,
rooms:[
  {
    roomNo:roomNo,
roomAccomodation:accomodation,
status:'free',
price:price
  }
],
Images:[
 {
   url:localStorage.getItem('Image1')
 },
 {
  url:localStorage.getItem('Image2')
},
{
  url:localStorage.getItem('Image3')
},
{
  url:localStorage.getItem('Image4')
},
{
  url:localStorage.getItem('Image5')
},
{
  url:localStorage.getItem('Image6')
}
],
adminUID:localStorage.getItem('admin_uid'),
branch_uid:localStorage.getItem('admin_uid')+key,
hotel_uid:key,

Avg_Rating:0,

price:price
}


  document.getElementById('loadingSHOW').style.display='none'

console.log(obj);


clientFirebase.firestore().collection("All_Hotel").doc(localStorage.getItem('admin_uid')+key).set(obj)
.then(() => {
  console.log("Document successfully written!");
})
.catch((error) => {
  console.error("Error writing document: ", error);
});





});

});



});

});


});

});

});

});

});

});

});

});



  }




  return (
    <>

<div id="loadingSHOW" style={{display:'none'}}>
<div class="loading"> Loading&#8230;</div>
<div className="progressDiv">
 <h3>
   Progress
 </h3>
 <br />
 <p>
 Upload Image {currentUpload} : {progress}%
 </p>

</div>
</div>

      <div className="content">
        <Row >

          <Col  md="11">
            <Card  className="card-user">
              <CardHeader>
                <CardTitle tag="h5">Branch Deail</CardTitle>
              </CardHeader>
              <CardBody>
                <Form>
                  <Row>
                    <Col className="pr-1" md="5">
                      <FormGroup>
                        <label>Hotel Branch Name</label>
                        <Input
                          defaultValue=""
                        onChange={(e)=>setName(e.target.value)}  
                          placeholder="london Branch etc"
                          type="text"
                        />
                      </FormGroup>
                      <p style={{color:'red',fontSize:11,height:12,marginTop:-10}}>{nameValidation}</p>
                    </Col>
                    <Col className="px-1" md="3">
                      <FormGroup>
                        <label>Phone Number</label>
                        <Input
                          defaultValue="michael23"
                          placeholder="+923223760042"
                          onChange={(e)=>setPhone(e.target.value)}  

                          type="Number"
                        />
                      </FormGroup>
                      <p style={{color:'red',fontSize:11,height:12,marginTop:-10}}>{phoneValidation}</p>

                    </Col>
                    <Col className="pl-1" md="4">
                      <FormGroup>
                        <label htmlFor="exampleInputEmail1">
                          Email address
                        </label>
                        <Input placeholder="Email"                
                         onChange={(e)=>setEmail(e.target.value)} 
                         type="email" />
                      </FormGroup>
                      <p style={{color:'red',fontSize:11,height:12,marginTop:-10}}>{emailValidation}</p>

                    </Col>
                  </Row>
                  <Row>
                    <Col className="pr-1" md="6">
                      <FormGroup>
                        <label> First Name(Branch manger)</label>
                        <Input
                          defaultValue=""
                          placeholder="Awais"
                          type="text"
                          onChange={(e)=>setFirstName(e.target.value)}
                        />
                      </FormGroup>
                      <p style={{color:'red',fontSize:11,height:12,marginTop:-10}}>{FirstnameValidation}</p>

                    </Col>
                    <Col className="pl-1" md="6">
                      <FormGroup>
                        <label>Last Name (Branch manger)</label>
                        <Input
                          defaultValue=""
                          placeholder="Ahmad"
                          type="text"
                          onChange={(e)=>setLastName(e.target.value)}

                        />
                      </FormGroup>
                      <p style={{color:'red',fontSize:11,height:12,marginTop:-10}}>{LastnameValidation}</p>
                    </Col>
                  </Row>
                  <Row>
                    <Col  md="4">
                      <FormGroup>
                        <label>Enter Room No</label>
                        <Input
                          defaultValue=""
                          placeholder="5"
                          type="number"
                          onChange={(e)=>setRoomNo(e.target.value)}
                        />
                      </FormGroup>
                      <p style={{color:'red',fontSize:11,height:12,marginTop:-10}}>{roomNoValidation}</p>

                    </Col>



                    <Col  md="4">
                      <FormGroup>
                        <label>Enter Price</label>
                        <Input
                          defaultValue=""
                          placeholder="100 (Don't put $)"
                          type="number"
                          onChange={(e)=>setPrice(e.target.value)}
                        />
                      </FormGroup>
                      <p style={{color:'red',fontSize:11,height:12,marginTop:-10}}>{priceValidation}</p>

                    </Col>


                    <Col className="px-1" md="4">
                      <FormGroup>
                        <label style={{marginRight:'5%'}}>Room Accommodation</label><br></br>
                        <div style={{paddingTop:'0px',marginTop:'-10px'}} class="btn-group">
  <button style={{backgroundColor:'#8C8C8C'}} type="button" class="btn btn-secondary dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
   {accomodation?accomodation:'Select'} 
  </button>
  <div class="dropdown-menu dropdown-menu-right">
    <button class="dropdown-item" onClick={()=>setaccomodation('1-2 Person')} type="button">1-2 Person</button>
    <button class="dropdown-item" onClick={()=>setaccomodation('2-4 Person')} type="button">2-4 person</button>
    <button class="dropdown-item" onClick={()=>setaccomodation('4-6 Person')} type="button">4-6 Person</button>
  </div>
</div>
                      </FormGroup>
                      <p style={{color:'red',fontSize:11,height:12,marginTop:-10}}>{accomodationValidation}</p>

                    </Col>
                  </Row>
                  <Row>
                    <Col md="12">
                      <FormGroup>
                        <label>Branch Address</label>
                        <Input
                          defaultValue=""
                          placeholder="Melbourne, Australia"
                          type="text"
                          onChange={(e)=>setAddress(e.target.value)}
                        />
                      </FormGroup>
                      <p style={{color:'red',fontSize:11,height:12,marginTop:-10}}>{addressValidation}</p>

                    </Col>
                  </Row>
                  <Row>
                    <Col className="pr-1" md="4">
                      <FormGroup>
                        <label>City</label>
                        <Input
                          defaultValue=""
                          placeholder="City"
                          type="text"
                          onChange={(e)=>setCity(e.target.value)}
                        />
                      </FormGroup>
                      <p style={{color:'red',fontSize:11,height:12,marginTop:-10}}>{cityValidation}</p>

                    </Col>
                    <Col className="px-1" md="4">
                      <FormGroup>
                        <label>Country</label>
                        <Input
                          defaultValue=""
                          placeholder="Country"
                          type="text"
                          onChange={(e)=>setCountry(e.target.value)}
                        />
                      </FormGroup>
                      <p style={{color:'red',fontSize:11,height:12,marginTop:-10}}>{countryValidation}</p>

                    </Col>
                    <Col className="pl-1" md="4">
                      <FormGroup>
                        <label>Postal Code</label>
                        <Input placeholder="ZIP Code"
                        onChange={(e)=>setZip(e.target.value)}
                        type="number" />
                      </FormGroup>
                      <p style={{color:'red',fontSize:11,height:12,marginTop:-10}}>{zipValidation}</p>

                    </Col>
                  </Row>
                  <Row>
                    <Col md="12">
                      <FormGroup>
                        <label>Details</label>
                        <Input
                          type="textarea"
                          onChange={(e)=>setDetails(e.target.value)}
                          defaultValue=""
                        />
                      </FormGroup>
                      <p style={{color:'red',fontSize:11,height:12,marginTop:-10}}>{DetailsValidation}</p>

                    </Col>
                    <Col md="12">
                      <FormGroup>
                        <label>Facilities</label>
                        <Input
                          type="textarea"
                          defaultValue=""
                          onChange={(e)=>setFacilities(e.target.value)}

                        />
                      </FormGroup>
                      <p style={{color:'red',fontSize:11,height:12,marginTop:-10}}>{facilitiesValidation}</p>

                    </Col>

                    <Col md="12">
                      <FormGroup>
                        <label>Select Images</label>
                       
                      </FormGroup>
                    </Col>


                    <div className="custom-file"  style={{width:'50%',marginTop:'30px',marginLeft:'15%'}}>
        <input  type="file"  accept="image/*" onChange={(e)=>setimage1(e.target.files[0])}  className="custom-file-input" id="customFile" />
        <label  id='fileNam' className="custom-file-label" htmlFor="customFile">{image1.name?image1.name:'Choose Hotel Picture'}</label>
        <p style={{color:'red',fontSize:11,height:12,marginTop:0}}>{image1Validation}</p>

      </div>
      <div className="custom-file"  style={{width:'50%',marginTop:'30px',marginLeft:'15%'}}>
        <input  type="file"  accept="image/*" onChange={(e)=>setimage2(e.target.files[0])} className="custom-file-input" id="customFile" />
        <label  id='fileNam' className="custom-file-label" htmlFor="customFile">{image2.name?image2.name:'Choose Hotel Picture'}</label> 
         <p style={{color:'red',fontSize:11,height:12,marginTop:0}}>{image2Validation}</p>

      </div>
      <div className="custom-file"  style={{width:'50%',marginTop:'30px',marginLeft:'15%'}}>
        <input  type="file"  accept="image/*"  onChange={(e)=>setimage3(e.target.files[0])} className="custom-file-input" id="customFile" />
        <label  id='fileNam' className="custom-file-label" htmlFor="customFile">{image3.name?image3.name:'Choose Hotel Picture'}</label>
        <p style={{color:'red',fontSize:11,height:12,marginTop:0}}>{image3Validation}</p>

      </div>
      <div className="custom-file"  style={{width:'50%',marginTop:'30px',marginLeft:'15%'}}>
        <input  type="file"  accept="image/*"  onChange={(e)=>setimage4(e.target.files[0])} className="custom-file-input" id="customFile" />
        <label  id='fileNam' className="custom-file-label" htmlFor="customFile">{image4.name?image4.name:'Choose Hotel Picture'}</label>
        <p style={{color:'red',fontSize:11,height:12,marginTop:0}}>{image4Validation}</p>

      </div>
      <div className="custom-file"  style={{width:'50%',marginTop:'30px',marginLeft:'15%'}}>
        <input  type="file"  accept="image/*"  onChange={(e)=>setimage5(e.target.files[0])} className="custom-file-input" id="customFile" />
        <label  id='fileNam' className="custom-file-label" htmlFor="customFile">{image5.name?image5.name:'Choose Hotel Picture'}</label>
        <p style={{color:'red',fontSize:11,height:12,marginTop:0}}>{image5Validation}</p>

      </div>
                <div className="custom-file"  style={{width:'50%',marginTop:'30px',marginLeft:'15%'}}>
        <input  type="file"  accept="image/*"   onChange={(e)=>setimage6(e.target.files[0])} className="custom-file-input" id="customFile" />
        <label  id='fileNam' className="custom-file-label" htmlFor="customFile">{image6.name?image6.name:'Choose Hotel Picture'}</label>
        <p style={{color:'red',fontSize:11,height:12,marginTop:0}}>{image6Validation}</p>

      </div>


                  </Row>
          
                  <Row style={{marginTop:'4%'}}>
                    <div className="update ml-auto mr-auto">
                      <Button
                        className="btn-round"
                        color="primary"
                        // type="submit"
                        onClick={()=>AddBranch()}
                      >
                        Add Branch
                      </Button>
                    </div>
                  </Row>
                </Form>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    </>
  );
}

export default Add;
